// extracted by mini-css-extract-plugin
export default {"buttonsContainer":"DriverScreen_buttonsContainer__IneX-","button":"DriverScreen_button__Qlyzz"};